import { render, staticRenderFns } from "./OrderWorkerPerformancePopup.vue?vue&type=template&id=0556083d&"
import script from "./OrderWorkerPerformancePopup.vue?vue&type=script&lang=js&"
export * from "./OrderWorkerPerformancePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports